<ion-content class="modal-border">
  <ion-header>
    <ion-toolbar text-center>
      <br />
      <ion-title><strong>{{paramObject.modalHeaderText}}</strong></ion-title>
      <br />
      <ion-buttons slot="end">
        <ion-button (click)="dismissModal()" size="large">
          <ion-icon name="close"></ion-icon>
        </ion-button>
      </ion-buttons>

      <div *ngIf="paramObject.modalType == 'ImportLesson'" class="form-group">
        <br /><br />
        <label for="file">Choose a File to upload</label>
        <div *ngIf="paramObject.allowedMedia == null">
          <input
            type="file"
            id="fileImport"
            (change)="handleImportZip($event.target.files)"
            accept="application/x-zip-compressed"
          />
        </div>
      </div>

      <div *ngIf="paramObject.modalType == 'ExcelImport'" class="form-group">
        <br /><br />
        <ion-title>Choose a Excel File to Upload</ion-title>
        <div style="padding: 1%">
          <div *ngIf="paramObject.allowedMedia == null" multiple>
            <input
              type="file"
              id="fileExcel"
              (change)="handleExcelFileInput($event.target.files)"
              accept=".xlsx"
              multiple
            />
            <!-- <p *ngIf="fileTypeError"> Please upload a valid Excel file (.xlsx or .xls)</p> -->
            <ion-item
              *ngIf="fileTypeError"
              style="
                padding: 2%;
                padding-left: 5%;
                padding-right: 5%;
                text-align: center;
              "
            >
              <ion-label style="color: rgb(231, 38, 38); text-align: center">
                Please upload a valid Excel file (.xlsx)
              </ion-label>
            </ion-item>
          </div>
        </div>
      </div>

      <div *ngIf="paramObject.modalType == 'Upload'" class="form-group">
        <label for="file">Choose a File to upload</label>
        <div
          *ngIf="paramObject.allowedMedia == 'All' || paramObject.allowedMedia == null"
          class="file-input-wrapper"
        >
          <button
            type="button"
            (click)="triggerFileInput()"
            class="custom-file-button"
          >
            Choose Files
          </button>
          <input
            type="file"
            id="fileUpload"
            (change)="handleFileInput($event)"
            accept="image/jpeg,application/pdf,video/mp4,application/x-zip-compressed,image/png"
            multiple
          />
        </div>
      </div>
    </ion-toolbar>
  </ion-header>

  <div padding>
    <ion-grid>
      <ion-row>
        <ion-col text-center> </ion-col>
      </ion-row>

      <div *ngIf="paramObject.modalType == 'Upload'" class="form-group">
        <ion-grid
          class="drop-box"
          (dragover)="handleDragOver($event)"
          (drop)="handleDrop($event)"
          *ngIf="!uploadDone && !ContentViewing"
        >
          <div class="shadow-box">
            <ion-col>
              Drag and drop files <br />
              <br />
              <ion-icon name="cloud-upload-outline" size="large"></ion-icon
              ><br />
            </ion-col>
          </div>
        </ion-grid>
      </div>

      <div *ngIf="paramObject.modalType == 'input'" text-center>
        <ion-row>
          <ion-col>
            <ion-item>
              <ion-label position="stacked"
                >{{paramObject.modalBodyText}}</ion-label
              >
              <ion-input
                [(ngModel)]="inputValue"
                (change)="onInputChange($event)"
                (keyup.enter)="onInputChange($event)"
              >
              </ion-input>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col
            class="modal-ion-col-bottom-buttons"
            style="width: 58% !important; left: 0 !important"
            col-6
          >
            <ion-button (click)="onCancel()" class="menuitem-ion-button"
              ><ion-icon name="arrow-dropleft"></ion-icon>Cancel</ion-button
            >
          </ion-col>
          <ion-col
            class="modal-ion-col-bottom-buttons"
            style="width: 58% !important; right: 0 !important"
            col-6
          >
            <ion-button (click)="onClose()" class="menuitem-ion-button"
              ><ion-icon name="checkmark-circle-outline"></ion-icon
              >Continue</ion-button
            >
          </ion-col>
        </ion-row>
      </div>

      <div *ngIf="paramObject.modalType == 'confirm'" text-center>
        <ion-row>
          <ion-col>
            <!-- <div style="white-space: pre-line">{{paramObject.modalBodyText}} </div> -->
            <!-- possible to use \n\r escape characters -->
            <div
              style="white-space: pre-line"
              [innerHTML]="paramObject.modalBodyText"
            ></div>

            <!-- possible to use <html> tags -->
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col
            class="modal-ion-col-bottom-buttons"
            style="width: 58% !important; left: 0 !important"
            col-6
          >
            <ion-button
              (click)="onButtonPress('no')"
              class="menuitem-ion-button"
              >No</ion-button
            >
          </ion-col>
          <ion-col
            class="modal-ion-col-bottom-buttons"
            style="width: 58% !important; right: 0 !important"
            col-6
          >
            <ion-button
              (click)="onButtonPress('yes')"
              class="menuitem-ion-button"
              ><ion-icon name="checkmark-circle-outline"></ion-icon
              >Yes</ion-button
            >
          </ion-col>
        </ion-row>
      </div>

      <div *ngIf="paramObject.modalType == 'Upload' " text-center>
        <ion-row>
          <ion-col> </ion-col>
        </ion-row>
        <ion-row>
          <ion-col> </ion-col>
        </ion-row>

        <ion-row>
          <!-- <ion-col> -->
          <div *ngIf="uploadDone == false">
            <ion-label>Loading in progress, please wait...</ion-label>
            <ion-progress-bar type="indeterminate"></ion-progress-bar>
          </div>

          <!-- Display preview if only one file is uploaded -->
          <ion-col>
            <div *ngIf="ContentUploadedMultipleFiles.length == 1">
              <div *ngIf="ContentViewing?.ContentType == 'video' ">
                <video
                  controls="controls"
                  preload="metadata"
                  autoplay="autoplay"
                  webkit-playsinline="webkit-playsinline"
                  class="videoPlayer"
                  style="width: 70%"
                >
                  <source src="{{ContentViewing?.url}}" type="video/mp4" />
                </video>
                <ion-icon
                  name="close-circle"
                  class="delete-icon-single"
                  (click)="deleteSingleFile()"
                ></ion-icon>
              </div>

              <div *ngIf="ContentViewing?.contentType == 'picture'">
                <img
                  src="{{ContentViewing?.url}}"
                  alt="XRS content"
                  style="
                    height: 500px !important;
                    width: 700px !important;
                    display: block;
                    margin-left: auto;
                    margin-right: auto;
                  "
                />
                <ion-icon
                  name="close-circle"
                  class="delete-icon-single"
                  (click)="deleteSingleFile()"
                ></ion-icon>
              </div>

              <div *ngIf="ContentViewing?.ContentType == 'document' ">
                <!-- <pdf-viewer [src]="pdfSrc" [render-text]="true" style="display: block;"></pdf-viewer> -->
                <!-- <simple-pdf-viewer #pdfViewer [src]="pdfSrc"></simple-pdf-viewer> -->
                <!-- <bn-ng-pdf-viewer [showAll]="true" [PDF]="pdfSrc" [pageNo]="1" [styleClass]="my-viewer-class">
                    </bn-ng-pdf-viewer> -->
                <ngx-extended-pdf-viewer
                  [src]="PDFLocation"
                  [showSidebarButton]="false"
                  [showFindButton]="false"
                  [showPagingButtons]="true"
                  [showZoomButtons]="true"
                  [showPresentationModeButton]="false"
                  [showOpenFileButton]="false"
                  [showPrintButton]="true"
                  [showDownloadButton]="true"
                  [showBookmarkButton]="false"
                  [showSecondaryToolbarButton]="false"
                  [showRotateButton]="true"
                  [showHandToolButton]="false"
                  [showScrollingButton]="false"
                  [showSpreadButton]="false"
                  [showPropertiesButton]="false"
                  [mobileFriendlyZoom]="zoom"
                  useBrowserLocale="true"
                  height="60vh"
                  (pagesLoaded)="onPagesLoaded($event)"
                  (pageRendered)="onPageRendered($event)"
                >
                </ngx-extended-pdf-viewer>
                <ion-icon
                  name="close-circle"
                  class="delete-icon-single"
                  (click)="deleteSingleFile()"
                ></ion-icon>
              </div>

              <div *ngIf="ContentViewing?.ContentType == 'HTML'">
                <iframe [src]="sanitizedURL"></iframe>
                <ion-icon
                  name="close-circle"
                  class="delete-icon-single"
                  (click)="deleteSingleFile()"
                ></ion-icon>
              </div>
            </div>

            <!-- Display only thumbnails when multiple files is uploaded-->
            <div
              *ngIf="ContentUploadedMultipleFiles.length > 1"
              class="file-grid"
            >
              <div
                *ngFor="let file of ContentUploadedMultipleFiles; let i = index"
                class="file-item"
              >
                <img
                  src="{{globals.GetXRSCustomContentURL() + 'Thumbnails/' + file.GUID + '.jpg'}}"
                />
                <ion-icon
                  name="close-circle"
                  class="delete-icon"
                  (click)="deleteFile(i)"
                ></ion-icon>
              </div>
            </div>
          </ion-col>
          <!-- </ion-col> -->
        </ion-row>
        <ion-row>
          <ion-col class="modal-ion-col-bottom-buttons" style="left: 0">
            <!-- <ion-button (click)="onCancelUpload()" class="menuitem-ion-button" >Cancel</ion-button> -->
            <ion-button
              (click)="onCloseUpload()"
              class="menuitem-ion-button"
              style="width: 110% !important; left: 0"
            >
              <ion-icon name="checkmark-circle-outline"></ion-icon>Save
            </ion-button>
          </ion-col>
        </ion-row>
      </div>

      <div *ngIf="paramObject.modalType == 'ExcelImport' " text-center>
        <ion-row>
          <ion-col> </ion-col>
        </ion-row>
        <ion-row>
          <ion-col> </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-item
              *ngIf="totalExcelFilesUploaded > 0 && totalExcelFilesProcessed > 0"
            >
              <ion-title>Upload progress</ion-title>
              <ion-progress-bar type="indeterminate"></ion-progress-bar>
            </ion-item>
            <ion-item>
              <ion-title
                >Total Files remaining : {{totalExcelFilesProcessed}}</ion-title
              >
            </ion-item>
          </ion-col>
        </ion-row>
        <ion-row *ngIf=" totalExcelFilesProcessed == 0">
          <ion-col>
            <ion-item>
              <ion-title>Upload Successful</ion-title>
            </ion-item>
            <ion-item *ngIf="totalExcelFilesUploaded > 1"
              >Please note that File upload order may not match server
              processing order, which may require a manual reordering.
            </ion-item>
          </ion-col>
        </ion-row>
        <ion-row
          *ngIf="uploadDone && !fileTypeError && totalExcelFilesProcessed == 0"
        >
          <ion-col class="modal-ion-col-bottom-buttons" style="left: 0">
            <!-- <ion-button (click)="onCancelUpload()" class="menuitem-ion-button" >Cancel</ion-button> -->
            <ion-button
              (click)="onCloseUpload()"
              class="menuitem-ion-button"
              style="width: 110% !important; left: 0"
            >
              <ion-icon name="checkmark-circle-outline"></ion-icon>Save
            </ion-button>
          </ion-col>
        </ion-row>
      </div>

      <div *ngIf="paramObject.modalType == 'contentViewer'" text-center>
        <ion-row>
          <ion-col>
            <div *ngIf="ContentViewing?.ContentType == 'video' ">
              <ion-row>
                <ion-col size="8">
                  <video
                    controls="controls"
                    preload="metadata"
                    autoplay="autoplay"
                    webkit-playsinline="webkit-playsinline"
                    class="videoPlayer"
                    style="display: inline-block; width: 100%; height: 100%"
                  >
                    <source src="{{ContentViewing?.url}}" type="video/mp4" />
                  </video>
                </ion-col>

                <ion-col size="4">
                  <ion-label>Description</ion-label>
                  <ion-item>
                    <ion-input
                      [(ngModel)]="ContentViewing.Description"
                    ></ion-input>
                  </ion-item>

                  <ion-label>Tags (comma seperated)</ion-label>
                  <ion-item>
                    <ion-textarea
                      [(ngModel)]="ContentViewing.Tags"
                      autoGrow="true"
                      style="width: 250px"
                    ></ion-textarea>
                  </ion-item>
                </ion-col>
              </ion-row>
            </div>

            <div *ngIf="ContentViewing?.contentType == 'picture'">
              <!-- <ion-button>
              <ion-icon name='print'></ion-icon>
              <ion-label>Print</ion-label>
            </ion-button> -->
              <!-- <img src="{{ContentViewing?.url}}" alt="XRS content" style="height:500px!important; width:700px !important; display: block; margin-left: auto; margin-right: auto;"/> -->
              <img src="{{ContentViewing?.url}}" alt="XRS content" />
            </div>

            <div *ngIf="ContentViewing?.ContentType == 'HTML'">
              <!-- <iframe [src]="ContentViewing.url" ></iframe> -->
              <!-- <iframe [src]="getURL()" ></iframe> -->
              <ion-label>HTML</ion-label>
              <iframe
                [src]="sanitizedURL"
                style="
                  width: 80%;
                  height: 92%;
                  position: fixed;
                  top: 0px;
                  left: 40px;
                  border: none;
                "
              ></iframe>
            </div>

            <div *ngIf="ContentViewing?.ContentType == 'document' ">
              <!-- <ion-button>
              <ion-icon name='print'></ion-icon>
              <ion-label>Print</ion-label>
            </ion-button> -->
              <!-- <pdf-viewer [src]="pdfSrc" [render-text]="true" style="display: block;"></pdf-viewer> -->
              <!-- <simple-pdf-viewer #pdfViewer [src]="pdfSrc"></simple-pdf-viewer> -->
              <!-- <bn-ng-pdf-viewer [showAll]="true" [PDF]="pdfSrc" [pageNo]="1" [styleClass]="my-viewer-class">
            </bn-ng-pdf-viewer> -->
              <ngx-extended-pdf-viewer
                [src]="PDFLocation"
                [showSidebarButton]="false"
                [showFindButton]="false"
                [showPagingButtons]="true"
                [showZoomButtons]="true"
                [showPresentationModeButton]="false"
                [showOpenFileButton]="false"
                [showPrintButton]="true"
                [showDownloadButton]="true"
                [showBookmarkButton]="false"
                [showSecondaryToolbarButton]="false"
                [showRotateButton]="true"
                [showHandToolButton]="false"
                [showScrollingButton]="false"
                [showSpreadButton]="false"
                [showPropertiesButton]="false"
                [mobileFriendlyZoom]="zoom"
                useBrowserLocale="true"
                height="60vh"
                (pagesLoaded)="onPagesLoaded($event)"
                (pageRendered)="onPageRendered($event)"
              >
              </ngx-extended-pdf-viewer>
            </div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="modal-ion-col-bottom-buttons" style="left: 0">
            <ion-button
              (click)="onCloseUpload()"
              class="menuitem-ion-button"
              style="width: 110% !important; left: 0"
              >Continue</ion-button
            >
          </ion-col>
        </ion-row>
      </div>

      <div *ngIf="paramObject.modalType == 'prompt'" text-center>
        <ion-row>
          <ion-col>
            <div
              style="white-space: pre-line"
              [innerHTML]="paramObject.modalBodyText"
            ></div>

            <br />
            <br />
            <br />
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="modal-ion-col-bottom-buttons" style="left: 0">
            <ion-button
              (click)="onClose()"
              class="menuitem-ion-button"
              style="width: 110% !important; left: 0"
              >Continue</ion-button
            >
          </ion-col>
        </ion-row>
      </div>

      <div
        *ngIf="paramObject.modalType == 'wizard'"
        text-center
        style="align-items: center"
      >
        <ion-grid>
          <ion-row>
            <ion-col size="3"></ion-col>
            <ion-col size="8">
              <ion-button
                (click)="inputValue = 'stsStructuredLesson';onClose()"
                class="menuitem-ion-button"
                >Use the STS Lesson format</ion-button
              >
              <br />
              <br />
              <br />

              <ion-button
                (click)="inputValue = 'customStructuredLesson';onClose()"
                class="menuitem-ion-button"
                >Create your own Lesson</ion-button
              >
            </ion-col>
            <ion-col size="2"></ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </ion-grid>
  </div>
</ion-content>
